module.exports = __webpack_public_path__ + "img/payment-providers.667afb42.svg";